document.addEventListener('DOMContentLoaded', () => {
    // all tabbed components on the page
    const tabbedContainers = document.querySelectorAll<HTMLElement>('.tabbed');

    // for each tabbed component, apply the following functions
    tabbedContainers.forEach(container => {
        const triggers = container.querySelectorAll<HTMLElement>('[data-tab-trigger]');
        const bodies = container.querySelectorAll<HTMLElement>('.tabbed__body');
        const desktopContentArea = container.querySelector<HTMLElement>('.tabbed__content');
        const isMobile = () => window.innerWidth < 992; // this is when the accordion styling will show

        function showTab(tabId: string, allowToggle = false) {
            const isCurrentlyActive = container.querySelector(`[data-tab-trigger="${tabId}"]`)?.classList.contains('active');
            const isMobileView = isMobile();

            // If on mobile and clicking the already active tab, collapse it
            if (allowToggle && isMobileView && isCurrentlyActive) {
                // Deactivate all triggers
                triggers.forEach(btn => btn.classList.remove('active'));

                // Hide all content blocks
                bodies.forEach(body => body.classList.add('d-none'));
                return; // exit early
            }

            // Otherwise, activate the selected tab
            triggers.forEach(btn => {
                btn.classList.toggle('active', btn.dataset.tabTrigger === tabId);
            });

            bodies.forEach(body => {
                const match = body.dataset.tab === tabId;
                body.classList.toggle('d-none', !match);

                if (match) {
                if (isMobileView) {
                    const trigger = container.querySelector<HTMLElement>(`[data-tab-trigger="${tabId}"]`);
                    if (trigger) {
                    trigger.insertAdjacentElement('afterend', body);
                    }
                } else {
                    if (desktopContentArea && !desktopContentArea.contains(body)) {
                    desktopContentArea.appendChild(body);
                    }
                }
                }
            });
        }

        // setup event listeners for when a tab is clicked
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const tabId = trigger.dataset.tabTrigger;
                if (tabId) {
                    showTab(tabId, true);
                }
            });
        });

        // initial state
        showTab('1');

        // reposition content on resize
        window.addEventListener('resize', () => {
            const activeTrigger = container.querySelector<HTMLElement>('[data-tab-trigger].active');
            const tabId = activeTrigger?.dataset.tabTrigger;
            if (tabId) {
                showTab(tabId);
            }
        });
    });
});